
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home.jsx';
import Page1 from './pages/Page1.jsx';
import Page2 from './pages/Page2.jsx';
import Page3 from './pages/Page3.jsx';
import Index from './pages/Index.jsx';
import Login from './pages/Login.js';
import Register from './pages/Register.js';
import PrivateRoute from './components/PrivateRoute';
import Profile from './pages/Profile';
import Pricing from './pages/Pricing';
import Password from './pages/Password';
import CreateQR from './pages/CreateQR';
import MyQRCode from './pages/MyQRCode';
import GroupUser from './pages/GroupUser';
import SubscriptionPage from "./pages/SubscriptionPage";
import CreatedPage from "./pages/CreatedPage";

function App() {

  const token = localStorage.getItem('token');

  return (
    <Router>
      <Routes>
        <Route path="/pages/:slug" element={<CreatedPage />} />
        {token ? (
          <Route path="/" element={<MyQRCode />} />
        ) : (
          <Route path="/" element={<Index />} />
        )}
        <Route element={<PrivateRoute />}>
          <Route path="/page1" element={<Page1 />} />
          <Route path="/page2" element={<Page2 />} />
          <Route path="/page3" element={<Page3 />} />
          <Route path="/home" element={<Home />} />
          <Route path="/my-qr-codes" element={<MyQRCode />} />
          <Route path="/create-qr" element={<CreateQR />} />

          <Route path="/group-users" element={<GroupUser />} />

          <Route path="/subscribe" element={<SubscriptionPage />} />
          
          <Route path="/profile" element={<Profile />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/password" element={<Password />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </Router>
  );
}

export default App;
